module.exports = __webpack_public_path__ + "brandon_bld_it-webfont.3d29457a3c940bfabda2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_bld_it-webfont.woff
// module id = 385
// module chunks = 7